import { Result, Text } from '@/uicomponents';
import { PageTitle } from '@/lib/hooks';
import { ResultGlyph } from '../result-glyph';

/**
 * Shown when an authenticated user does not hold a role that grants access
 * to the platform UI. Post-NPJB-350, every browser user MUST hold either
 * `platform_user` or `admin`; anyone holding neither lands here.
 */
export function NoAccessScreen() {
  return (
    <>
      <PageTitle title='Access Denied' />
      <Result
        icon={<ResultGlyph tone='error' />}
        title={
          <Text variant='pageTitle' headingLevel={1} family='display'>
            Access Denied
          </Text>
        }
        subTitle="Your account doesn't have access to the platform. Contact your administrator."
      />
    </>
  );
}
